<div class="flex flex-col gap-4 rounded-md bg-white p-4 shadow-md">
  <div class="flex flex-row items-center gap-4">
    <h3 class="!m-0 flex grow !font-bold">Marketing Campaigns</h3>

    <a [routerLink]="[]" (click)="openDialog()">See More</a>
  </div>

  @if (patient().metadata?.receiveMarketing === false) {
    <pr-information-box>
      Patient has opted-out of Marketing Communications
    </pr-information-box>
  }

  <div class="flex flex-col gap-2">
    @for (entry of activeCampaignEntries(); track entry.ref.path) {
      <div class="flex flex-row flex-wrap items-center gap-2">
        <div class="flex grow flex-col">
          @if (entry | map: getCampaign$ : this | async; as campaign) {
            <a
              [prBrandRouterLink]="
                (entry | map: brandLinks.marketingCampaignEntry).segments
              "
            >
              {{ campaign.name }}
            </a>
          }
          <div class="text-xs opacity-50">
            {{ entry.createdAt | moment | amDateFormat: dateFormat }}
          </div>
        </div>
        <pr-campaign-entry-status
          [status]="entry.status"
          [errorMessage]="entry.errorMessage"
        />
      </div>
    } @empty {
      <pr-empty-state
        type="text"
        explicitTitle="No Active Marketing Campaigns"
      />
    }
  </div>
</div>
